/* global I18n */

// see https://secure.helpscout.net/settings/beacons/
import $ from "cash-dom"

const default_options = {
  color: "#0099FF",
  labels: I18n.t("js.helpscout.site.labels")
}

const helpscout_loader = () => {
  if (window.Beacon) return window.Beacon

  // eslint-disable-next-line
   !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});

  window.Beacon("init", window.gon.helpscout_beacon_token)
  window.Beacon("identify", get_user_information())
  window.Beacon("config", Object.assign(default_options, get_options()))
  // saving this flag to Beacon.is_ready didn't work on all browsers
  window.Beacon("on", "ready", () => (window.beacon_is_ready = true))
  // closes the beacon before saving the current page to cache
  // otherwise it would show a broken beacon when going back in history
  document.addEventListener("turbo:visit", () => {
    if (!window.Beacon) return

    window.Beacon("close")
    window.Beacon = undefined
  })
  return window.Beacon
}

const get_user_information = () => {
  if (!window.gon.current_user) return {}
  return {
    email: window.gon.current_user.email,
    // Identifies a user in Secure Mode. It enables identity verification
    // to protect the user information and conversation history
    signature: window.gon.helpscout_beacon_signature
  }
}

const get_options = () => {
  if ($("body.training").length) {
    return {
      color: "#3A5062",
      labels: I18n.t("js.helpscout.trainer.labels")
    }
  } else if ($("body.pricing").length) {
    return {
      color: "#3A5062",
      hideFABLabelOnMobile: true,
      display: {
        style: "iconAndText",
        text: I18n.t("js.helpscout.text"),
        textAlign: "right",
        iconImage: "message",
        position: "left"
      }
    }
  }
}

export default helpscout_loader
